<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      buttonName="导出"
      @openAddDialog="exportInfo"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      addShowPower="/fin/adminAcctDtlExport"
      buttonType="warning"
      :totalShow="true"
      totalShowType="purple"
      @totalLookDialog="totalLookDialog"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
      <el-form-item label="业务类型">
        <el-select v-model="formModel.busiType" filterable>
          <el-option
            v-for="item in busiTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交易类型">
        <el-select v-model="formModel.tranType" filterable>
          <el-option
            v-for="item in tranTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作类型">
        <el-select v-model="formModel.optType">
          <el-option
            v-for="item in optTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="原路线名称">
        <el-select v-model="formModel.oldLineId" filterable>
          <el-option
            v-for="item in topShortNames"
            :key="item.id"
            :label="item.shortName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="目标路线名称">
        <el-select v-model="formModel.newLineId" filterable>
          <el-option
            v-for="item in topShortNames"
            :key="item.id"
            :label="item.shortName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="变更日期">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatId"
        label="机构简称"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tranId"
        label="订单号"
        min-width="150"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="busiType"
        label="业务类型"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tranType"
        label="交易类型"
        min-width="100"
        :formatter="formatTranTypee"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="optType"
        label="操作类型"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <!--<p>{{scope.row.optType == 1 ? '正向交易' : '负向交易'}}</p>-->
          <p
            :class="[
              { 'text-green': scope.row.optType == 1 },
              { 'text-red': scope.row.optType == 2 },
            ]"
          >
            {{ scope.row.optType == 1 ? "+" : "-" }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="oldLineId"
        label="原线路名称"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="newLineId"
        label="目标线路名称"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="tranAmt"
        label="变动金额（元）"
        min-width="130"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.tranAmt * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="变动时间"
        min-width="160"
      ></el-table-column>
    </common-table>
    <show-info-dialog
      title="合计"
      :show="true"
      ref="showInfoDialog"
      dialogWidth="400px"
      class="showInfoDialog"
    >
      <div>
        <p>变动金额：{{ toDoubleThousands((dialogObj * 100) / 10000) }}元</p>
      </div>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";

import FinanceService from "service/FinanceService";
import OrganService from "service/OrganService";
import StatisticsService from "service/StatisticsService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";
import TimeRange from "service/constant/TimeRange";

export default {
  name: "platformaccountdetails",
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
    ShowInfoDialog,
  },
  data() {
    return {
      submitService: FinanceService.getAdminAccDtl,
      formModel: {
        tatSimpleId: "",
        tranType: "",
        busiType: "",
        optType: "",
        newLineId: "",
        oldLineId: "",
        time: TimeRange.dayRange,
      },
      busiTypes: [],
      all: [
        {
          id: "",
          simpleName: "全部",
        },
      ],
      tableData: [],
      page: {},
      params: {},
      optTypes: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "收入（+）",
        },
        {
          value: "2",
          label: "支出（-）",
        },
      ],

      tranTypes: [],
      isPage: false,
      dialogObj: "", //金额
      topShortNames: [],
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
    this.getTypeNames("交易类型", (res) => {
      this.tranTypes = [
        {
          dictKey: "",
          dictValue: "全部",
        },
        ...res,
      ];
    });
    this.getTypeNames("业务类型", (res) => {
      this.busiTypes = [
        {
          dictKey: "",
          dictValue: "全部",
        },
        ...res,
      ];
    });
    this.getShortNames("", (res) => {
      this.topShortNames = [
        {
          id: "",
          shortName: "全部",
        },
        ...res,
      ];
    });
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      this.params = {
        userId: this.userId,
        tatSimpleId: this.formModel.tatSimpleId,
        tranType: this.formModel.tranType,
        busiType: this.formModel.busiType,
        optType: this.formModel.optType,
        newLineId: this.formModel.newLineId,
        oldLineId: this.formModel.oldLineId,
        startDate: this.formModel.time[0],
        endDate: this.formModel.time[1],
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      if (this.formModel.time.length == 0) {
        delete this.params.startDate;
        delete this.params.endDate;
      }

      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  methods: {
    formatTranTypee(row, column, cellValue) {
      let value = "";
      this.tranTypes.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value ? value : "--";
    },
    // 合计
    totalLookDialog() {
      const tatSimpleId = this.formModel.tatSimpleId;
      const tranType = this.formModel.tranType;
      const busiType = this.formModel.busiType;
      const optType = this.formModel.optType;
      const startDate = this.formModel.time[0];
      const endDate = this.formModel.time[1];
      this.doLoad(
        FinanceService.getMoney,
        {
          tatSimpleId: tatSimpleId,
          tranType: tranType,
          busiType: busiType,
          optType: optType,
          startDate: startDate,
          endDate: endDate,
        },
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents.tranAmt;
            this.dialogObj = result;
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    exportInfo() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "adminAcctDtlExport",
            "",
            "/fin/"
          )
        : "";
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        FinanceService.getAdminAccDtl,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;

            this.page.currentPage = result.current;
            this.page.pageSize = result.size;
            this.page.total = result.total;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/RepaymentDetail.vue